var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "ModalFullScreen",
        { attrs: { size: "xl" }, on: { close: _vm.closeModal } },
        [
          _c("ModalContent", { staticClass: "relative h-72 w-full" }, [
            _c(
              "span",
              {
                staticClass:
                  "cursor-pointer flex items-center justify-center absolute top-0 right-0 z-50",
                on: { click: _vm.closeModal },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "mb-0.5",
                    attrs: {
                      width: "26",
                      height: "26",
                      viewBox: "0 0 13 12",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M10.728 1.75737C8.38605 -0.584572 4.58465 -0.584572 2.24271 1.75737C-0.0992269 4.0993 -0.0992267 7.90071 2.24271 10.2426C4.58465 12.5846 8.38605 12.5846 10.728 10.2426C13.0699 7.90071 13.0699 4.0993 10.728 1.75737ZM7.75814 8.12133L6.48535 6.84853L5.21256 8.12133C4.97921 8.35467 4.59738 8.35467 4.36403 8.12133C4.13069 7.88798 4.13069 7.50614 4.36403 7.2728L5.63682 6.00001L4.36403 4.72721C4.13069 4.49387 4.13069 4.11203 4.36403 3.87869C4.59738 3.64534 4.97921 3.64534 5.21256 3.87869L6.48535 5.15148L7.75814 3.87869C7.99149 3.64534 8.37333 3.64534 8.60667 3.87869C8.84002 4.11203 8.84002 4.49387 8.60667 4.72721L7.33388 6.00001L8.60667 7.2728C8.84002 7.50614 8.84002 7.88798 8.60667 8.12133C8.37333 8.35467 7.99149 8.35467 7.75814 8.12133Z",
                        fill: "#1A7BEE",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm.callSuccessMessage
              ? _c(
                  "div",
                  { staticClass: "text-gray-800 text-xl text-center" },
                  [
                    _c("div", { staticClass: "flex py-5 justify-center" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M1 30C1 45.9906 14.0094 59 30 59C45.9906 59 59 45.9906 59 30C59 14.0094 45.9906 1 30 1C14.0094 1 1 14.0094 1 30ZM45.1006 24.8006C46.2331 23.6681 46.2331 21.8319 45.1006 20.6994C43.9681 19.5669 42.1319 19.5669 40.9994 20.6994L27.1 34.5988L20.4506 27.9494C19.3181 26.8169 17.4819 26.8169 16.3494 27.9494C15.2169 29.0819 15.2169 30.9181 16.3494 32.0506L25.0494 40.7506C26.1819 41.8831 28.0181 41.8831 29.1506 40.7506L45.1006 24.8006Z",
                              fill: "#1A6C3B",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("p", [
                      _vm._v("You have successfully added "),
                      _c("span", { staticClass: "font-bold" }, [
                        _vm._v(_vm._s(_vm.getSelectedNumberOfManagers)),
                      ]),
                      _vm._v(" additional managers to your Premium plan."),
                    ]),
                    _c("p", { staticClass: "mt-4" }, [
                      _vm._v("The total cost of your additional managers is "),
                      _c("span", { staticClass: "font-bold" }, [
                        _vm._v(
                          "$" +
                            _vm._s(
                              _vm.selectedSubscriptionPlanId
                                ? Number(_vm.managersPrice.replace("$", "")) -
                                    149
                                : ""
                            )
                        ),
                      ]),
                      _vm._v(" and will be billed together "),
                      _c("br"),
                      _vm._v(" with your next invoice on "),
                      _c("span", { staticClass: "font-bold" }, [
                        _vm._v(_vm._s(_vm.getBillCurrentPeriodEndDate)),
                      ]),
                      _vm._v(". "),
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex py-5 justify-center" },
                      [
                        _c(
                          "UiButton",
                          {
                            attrs: { variant: "secondary" },
                            on: { click: _vm.onClosingModalSuccessModal },
                          },
                          [
                            _c("span", { staticClass: "text-xl font-normal" }, [
                              _vm._v("Continue"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _c(
                  "div",
                  [
                    _c(
                      "LoadingOverlay",
                      {
                        attrs: {
                          loading: _vm.isLoading,
                          hasData: _vm.subscriptionPlansExist,
                        },
                      },
                      [
                        _vm.subscriptionPlansExist
                          ? _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex font-bold space-x-1 h-7 items-start text-xl",
                                    attrs: { id: "modal-heading" },
                                  },
                                  [_c("p", [_vm._v("Add Managers")])]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-between align-center w-full mt-16 gap-8",
                                  },
                                  [
                                    _c(
                                      "FormGroup",
                                      {
                                        staticClass: "w-full",
                                        attrs: { title: "Number of managers" },
                                      },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.selectedSubscriptionPlanId,
                                                expression:
                                                  "selectedSubscriptionPlanId",
                                              },
                                            ],
                                            staticClass:
                                              "bg-gray-50 border border-gray-300 outline-none text-gray-900 text-sm font-bold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500",
                                            attrs: { id: "managers" },
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.selectedSubscriptionPlanId =
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                              },
                                            },
                                          },
                                          _vm._l(
                                            _vm.sortedSubscriptionPlans,
                                            function (plan, index) {
                                              return _c(
                                                "option",
                                                {
                                                  key: index,
                                                  attrs: {
                                                    disabled:
                                                      _vm.isOptionDisabled(
                                                        plan
                                                      ),
                                                  },
                                                  domProps: { value: plan.id },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        plan.inner_name ===
                                                          "PREMIUMPLUSFIVE"
                                                          ? "5"
                                                          : plan.inner_name ===
                                                            "PREMIUMPLUSTEN"
                                                          ? "10"
                                                          : plan.inner_name ===
                                                            "PREMIUMPLUSFIFTEEN"
                                                          ? "15"
                                                          : plan.inner_name ===
                                                            "PREMIUMPLUSTWENTY"
                                                          ? "20"
                                                          : plan.inner_name ===
                                                            "PREMIUMPLUSTWENTYFIVE"
                                                          ? "25"
                                                          : plan.inner_name ===
                                                            "PREMIUMPLUSTHIRTY"
                                                          ? "30"
                                                          : plan.inner_name ===
                                                            "PREMIUMPLUSTHIRTYFIVE"
                                                          ? "35"
                                                          : plan.inner_name ===
                                                            "PREMIUMPLUSFORTY"
                                                          ? "40"
                                                          : plan.inner_name ===
                                                            "PREMIUMPLUSFORTYFIVE"
                                                          ? "45"
                                                          : plan.inner_name ===
                                                            "PREMIUMPLUSFIFTY"
                                                          ? "50"
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "FormGroup",
                                      {
                                        staticClass: "w-full",
                                        attrs: {
                                          title: "Additional Monthly Cost",
                                        },
                                      },
                                      [
                                        _c(
                                          "select",
                                          {
                                            staticClass:
                                              "appearance-none bg-transparent border border-gray-300 text-gray-900 text-sm italic rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                            attrs: { disabled: "" },
                                          },
                                          [
                                            _c("option", [
                                              _vm._v(
                                                " $" +
                                                  _vm._s(
                                                    _vm.selectedSubscriptionPlanId
                                                      ? Number(
                                                          _vm.managersPrice.replace(
                                                            "$",
                                                            ""
                                                          )
                                                        ) - 149
                                                      : ""
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "w-full mt-4" },
                                      [
                                        _vm.isCurrentSubscription(
                                          _vm.selectedSubscriptionPlanId,
                                          _vm.currentSubscriptionPlanId
                                        )
                                          ? _c("div")
                                          : _vm._e(),
                                        _c(
                                          "UiButton",
                                          {
                                            attrs: {
                                              fullWidth: "",
                                              disabled:
                                                !_vm.selectedSubscriptionPlanId,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showSubscriptionActionModal(
                                                  _vm.selectedSubscriptionPlanId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-md" },
                                              [_vm._v("Add to Plan")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.alertDialogShown
                                  ? _c("CardRequiredModal", {
                                      on: {
                                        close: () =>
                                          (_vm.alertDialogShown = false),
                                        add: _vm.redirectToAccountSettings,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _c("p", { staticClass: "pt-5 text-xl" }, [
                              _vm._v(" Coming soon "),
                            ]),
                      ]
                    ),
                  ],
                  1
                ),
          ]),
        ],
        1
      ),
      _vm.subscriptionActionModalShown
        ? _c(
            "SubscriptionActionModal",
            {
              attrs: {
                subscription: _vm.chosenSubscription.subscription,
                title: _vm.chosenSubscription.title,
                managersPrice: _vm.managersPrice,
                getSelectedNumberOfManagers: _vm.getSelectedNumberOfManagers,
                selectedSubscriptionPlanId: _vm.selectedSubscriptionPlanId,
              },
              on: { close: _vm.onSubscriptionActionModalClose },
            },
            [
              _c(
                "form",
                { staticClass: "w-full", on: { submit: _vm.submitAction } },
                [
                  _vm.chosenSubscription.paymentCardRequired
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            { staticClass: "pb-5" },
                            [
                              _c(
                                "h3",
                                { staticClass: "mb-2 text-center font-bold" },
                                [_vm._v("Add Credit Card")]
                              ),
                              _c("PaymentCardForm", {
                                on: { change: _vm.onPaymentCardDataChange },
                              }),
                              _vm.isErrorShown
                                ? _c("FormError", {
                                    staticClass: "pt-1",
                                    attrs: { errorMessage: _vm.errorMessage },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("ModalSectionsDivider"),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _vm.isErrorShown
                            ? _c("FormError", {
                                staticClass: "pt-1",
                                attrs: { errorMessage: _vm.errorMessage },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                  _c(
                    "div",
                    { staticClass: "flex py-5 justify-center" },
                    [
                      _c(
                        "UiButton",
                        {
                          staticClass: "mr-2",
                          attrs: { variant: "secondary" },
                          on: { click: _vm.onSubscriptionActionModalClose },
                        },
                        [_vm._v(" Cancel ")]
                      ),
                      _c(
                        "UiButton",
                        {
                          attrs: {
                            processing: _vm.processing,
                            disabled: _vm.actionDisabled,
                          },
                          on: { click: _vm.submitAction },
                        },
                        [_vm._v(" Upgrade ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }